import { Button } from "@mui/material";
import React from "react";
import Fonts from "../../Config/Fonts";
import Colors from "../../theme/Colors";

const DeleteConfirmationPopup = ({ isVisible, onCancel, onDelete, title, icons }) => {
  if (!isVisible) return null; // Render nothing if not visible

  return (
    <div
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.6)", // Background overlay
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000, // Ensure it's above other content
      }}
    >
      {/* Modal Content */}
      <div
        style={{
          backgroundColor: "white",
          width: "20%",
          padding: "20px 10px",
          borderRadius: "8px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.6)",
          textAlign: "center",
        }}
      >
        {/* Centered Image */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: '20px',
            marginBottom: '10px'
          }}
        >
          <img
            src={icons}
            style={{ height: "62px", width: "62px", objectFit: "cover" }}
            alt="Delete Icon"
          />
        </div>

        {/* Content Text */}
        <div
          style={{
            width: "100%",
            padding: "0px 68px",
            maxWidth: "105%",
          }}
        >
          <span
            style={{
              fontSize: 22,
              fontWeight: "600",
              textAlign: "center",
              fontFamily: Fonts.Poppins,
              color: Colors.black
            }}
          >
           {title}
          </span>
        </div>

        {/* Actions */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "16px",
            marginTop: "20px",
            marginBottom: '20px',
            width: "100%",
          }}
        >
          <Button
            onClick={onCancel}
            variant="outlined"
            sx={{
              fontSize: 14,
              fontWeight: "500",
              fontFamily: Fonts.Poppins,
              color: Colors.paginationTitle,
              width: "40%",
              bgcolor: Colors.white,
              transition: "background-color 0.3s, color 0.3s",
              border: '1px solid #363740',
              "&:hover": {
                backgroundColor: Colors.adminPrimaryColor,
                color: Colors.white,
                border: "0px",
              },
            }}
          >
            No
          </Button>
          <Button
            onClick={onDelete}
            variant="contained"
            color="error"
            sx={{
              fontSize: 14,
              fontWeight: "500",
              fontFamily: Fonts.Poppins,
              color: Colors.paginationTitle,
              width: "40%",
              bgcolor: Colors.white,
              transition: "background-color 0.3s, color 0.3s",
              border: '1px solid #363740',
              "&:hover": {
                backgroundColor: Colors.adminPrimaryColor,
                color: Colors.white,
                border: "0px",
              },
            }}
          >
            Yes
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationPopup;
